import { Smartphone, Tablet, MonitorPlay, ChefHat } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { SectionHead } from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/assets";

const icons = [Smartphone, Tablet, MonitorPlay, ChefHat];

export const Ecosystem = () => {
  const { t } = useLang();
  const imgs = [IMAGES.shotApp, IMAGES.shotKiosk, IMAGES.shotMonitor, IMAGES.shotKds];

  return (
    <section id="ecosystem" className="py-20 md:py-28 bg-surface" data-testid="ecosystem-section">
      <div className="mx-auto max-w-[1280px] px-5 md:px-8">
        <SectionHead label={t.ecosystem.label} title={t.ecosystem.title} subtitle={t.ecosystem.subtitle} />
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.ecosystem.cards.map((c, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={i} delay={i * 0.08}>
                <div className="card overflow-hidden h-full group hover:-translate-y-1 hover:shadow-[0_20px_50px_-20px_rgba(0,0,0,0.18)]" data-testid={`ecosystem-card-${i}`}>
                  <div className="h-56 overflow-hidden bg-white border-b border-line">
                    <img src={imgs[i]} alt={c.title} loading="lazy" decoding="async" className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-700" data-testid={`ecosystem-image-${i}`} />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-2 text-tricolor-green">
                      <Icon size={18} />
                      <span className="text-[11px] font-semibold uppercase tracking-[0.12em]">{c.tag}</span>
                    </div>
                    <h3 className="mt-3 font-display font-bold text-lg text-ink">{c.title}</h3>
                    <p className="mt-2 text-sm text-muted leading-relaxed">{c.body}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
